import { z } from "zod";
import { AuditTrailEntryType } from "../AuditTrailEntryType.js";
// Interview (independent assessment) audit `data` schemas. See `registry.ts` for the
// audit-data leniency contract these follow.
// A doctor reference: either an `id` or a `userId`, plus a `name`.
const doctorRefSchema = z.object({
    id: z.string().nullish(),
    userId: z.string().nullish(),
    name: z.string().nullish(),
});
const timeRangeSchema = z.object({
    start: z.string(),
    end: z.string(),
});
// Opaque status-transition metadata (statuses, ids, counts).
const transitionSchema = z.unknown();
export const interviewCreatedDataSchema = z.object({
    after: transitionSchema,
});
export const interviewUpdatedDataSchema = z.object({
    doctors: z.array(doctorRefSchema).nullish(),
    changedFields: z.array(z.string()).nullish(),
});
export const interviewCancelledDataSchema = z.object({
    before: transitionSchema,
    after: transitionSchema,
    doctors: z.array(doctorRefSchema).nullish(),
});
// interviewParticipantAdded and interviewParticipantReContacted share this shape.
export const interviewInviteDataSchema = z.object({
    after: transitionSchema,
    inviteSource: z.string().nullish(), // "known" | "search"
    contactTarget: z.string().nullish(), // "team" | "doctor"
    recipientTeamName: z.string().nullish(),
    // Not part of the written payload — added downstream when entries are grouped.
    _groupedDoctorNames: z.array(z.string()).nullish(),
});
export const interviewParticipantAcceptedDataSchema = z.object({
    before: transitionSchema,
    after: transitionSchema,
});
export const interviewParticipantRejectedDataSchema = z.object({
    before: transitionSchema,
    after: transitionSchema,
});
export const interviewParticipantConfirmedDataSchema = z.object({
    before: transitionSchema,
    after: transitionSchema,
    confirmedDoctor: doctorRefSchema.nullish(),
    revokedDoctors: z.array(doctorRefSchema).nullish(),
    timeRanges: z.array(timeRangeSchema).nullish(),
});
export const interviewParticipantRevokedDataSchema = z.object({
    before: transitionSchema,
    after: transitionSchema,
    context: z.string().nullish(), // e.g. "unconfirmed"
    unconfirmedDoctor: doctorRefSchema.nullish(),
    restoredDoctors: z.array(doctorRefSchema).nullish(),
    timeRanges: z.array(timeRangeSchema).nullish(),
});
export const interviewParticipantRestoredDataSchema = z.object({
    before: transitionSchema,
    after: transitionSchema,
});
// Audit type → schema entries for this file, composed in ../registry.ts.
export const interviewAuditDataRegistry = {
    [AuditTrailEntryType.interviewCreated]: interviewCreatedDataSchema,
    [AuditTrailEntryType.interviewUpdated]: interviewUpdatedDataSchema,
    [AuditTrailEntryType.interviewCancelled]: interviewCancelledDataSchema,
    [AuditTrailEntryType.interviewParticipantAdded]: interviewInviteDataSchema,
    [AuditTrailEntryType.interviewParticipantReContacted]: interviewInviteDataSchema,
    [AuditTrailEntryType.interviewParticipantAccepted]: interviewParticipantAcceptedDataSchema,
    [AuditTrailEntryType.interviewParticipantRejected]: interviewParticipantRejectedDataSchema,
    [AuditTrailEntryType.interviewParticipantConfirmed]: interviewParticipantConfirmedDataSchema,
    [AuditTrailEntryType.interviewParticipantRevoked]: interviewParticipantRevokedDataSchema,
    [AuditTrailEntryType.interviewParticipantRestored]: interviewParticipantRestoredDataSchema,
};
//# sourceMappingURL=interview.js.map